module.exports = __webpack_public_path__ + "img/kabin-pota.be68c476.png";